<template>
    <div
        class="flex hover:scale-95 transform transition-all group"
        id="image"
        @click="clickAction"
        v-if="user"
    >
        <div
            class="relative top flex justify-center items-center rounded-full bg-white w-full h-full shadow-lg cursor-pointer"
        >
            <div
                v-if="isEditable"
                class="w-full h-full absolute top-0 left-0 bg-opacity-0 bg-black group-hover:bg-opacity-20 rounded-full transition-opacity flex items-center justify-center"
            >
                <upload-icon
                    :fillClass="'fill-white'"
                    class="opacity-0 group-hover:opacity-100 transition-opacity"
                />
                <input
                    type="file"
                    hidden
                    ref="fileInput"
                    accept="image/png, image/jpeg"
                    @change="updateImage"
                />
            </div>
            <h3
                v-if="computedUrl == null && state.preview == null"
                :class="`text-grey font-semibold text-lg select-none`"
            >
                {{ acronym }}
            </h3>
            <img
                :src="computedUrl ? computedUrl : state.preview"
                :class="`w-full h-full rounded-full`"
                alt=""
                v-else
            />
            <button
                v-if="isEditable"
                @click.stop="
                    $emit('emitDelete');
                    state.preview = null;
                "
                class=" absolute -top-1 -right-1 w-6 h-6 rounded-full flex justify-center items-center bg-primary overflow-hidden transition-all opacity-0 hover:bg-primary-dark group-hover:opacity-100"
            >
                <cross-icon
                    class="w-3 h-3"
                    :fillClass="'fill-white'"
                ></cross-icon>
            </button>
        </div>
    </div>
</template>

<script>
import { computed, defineComponent, reactive, ref } from "vue";
import makeAcronym from "../../common/acronym";
import { base64ToBlobUrl } from "../../common/fileTypeHelper";

export default defineComponent({
    name: "AvatarBubble",
    components: {},
    props: {
        isEditable: { type: Boolean, required: false },
        user: { required: true },
    },
    emits: ["change", "emitDelete", "click"],
    setup(props, ctx) {
        const state = reactive({
            preview: null,
        });
        const fileInput = ref();

        function clickAction() {
            ctx.emit("click");
            if (!props.isEditable) {
                return;
            }
            fileInput.value.click();
        }
        function updateImage(e) {
            const file = e.target.files[0];
            if (file == null) {
                return;
            }
            state.preview = URL.createObjectURL(file);
            ctx.emit("change", file);
        }

        const acronym = computed(() => makeAcronym(props.user.full_name));
        const computedUrl = computed(() => {
            if (!props.user.avatar) {
                return null;
            }

            return base64ToBlobUrl({
                base: props.user.avatar.base,
                mimeType: props.user.avatar.mime,
            });
        });

        return {
            state,
            updateImage,
            clickAction,
            acronym,
            fileInput,
            computedUrl,
        };
    },
});
</script>
